import { createContext, useContext } from 'react';
import type {
  ApuracaoCFOPItem,
  ApuracaoCFOPDocumentosFiltros,
  ApuracaoCFOPStatus,
  ApuracaoCFOPFiltros,
} from '@/services/ApuracaoCFOP';

export type SelectedCst = {
  cfop: string;
  cst: string | null;
  indOper: number;
};

export type ApuracaoCFOPContextValue = {
  selecaoMensalValida: boolean;
  buscaAplicada: boolean;

  handleBuscar: () => void;
  handleLimparFiltrosGlobais: () => void;

  lista: ApuracaoCFOPItem[];
  isLoadingTabela: boolean;
  filtrosAplicados: ApuracaoCFOPFiltros;

  selectedCfop: string | null;
  setSelectedCfop: (cfop: string | null) => void;

  selectedCst: SelectedCst | null;
  setSelectedCst: (v: SelectedCst | null) => void;

  documentosFiltros: ApuracaoCFOPDocumentosFiltros | null;

  cacheStatus: ApuracaoCFOPStatus | null;
  isReprocessando: boolean;
  handleReprocessar: () => void;
};

export const ApuracaoCFOPContext = createContext<ApuracaoCFOPContextValue | null>(null);

export function useApuracaoCFOPContext(): ApuracaoCFOPContextValue {
  const ctx = useContext(ApuracaoCFOPContext);
  if (!ctx) throw new Error('useApuracaoCFOPContext deve ser usado dentro de ApuracaoCFOPProvider');
  return ctx;
}
